import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

// item 179 — the editable 50-state sales-tax rate table
export interface StateTaxRateItem {
  stateCode: string;
  rate: number;
}

export interface StateTaxRates {
  rates: StateTaxRateItem[];
  defaultState?: string; // item 210 — the company default tax state (prefills new docs)
}

const getStateTaxRates = async (): Promise<StateTaxRates> => {
  const { data } = await axios.get(`${apiUrl}settings/StateTaxRates`);
  return data;
};

const useStateTaxRates = () => {
  const queryClient = useQueryClient();
  const query = useQuery('stateTaxRates', getStateTaxRates);

  const mutation = useMutation(
    (payload: StateTaxRates) => axios.post(`${apiUrl}settings/StateTaxRates`, payload),
    { onSuccess: () => queryClient.invalidateQueries('stateTaxRates') },
  );

  return {
    ...query,
    rates: query.data?.rates ?? [],
    defaultState: query.data?.defaultState ?? 'NV', // item 210
    tryUpdate: mutation.mutateAsync,
    isSaving: mutation.isLoading,
  };
};

export default useStateTaxRates;
